import {doc} from '../docs.js';
import ZTracker from '../../custom/ZTracker.js';

doc(
    "ztracker",
    {
    },
    "A tracker for showing/editing a pattern like in the 90s");

export const tracker = (object) => {
    object.effect =  new ZTracker(object);
    return () => {};
};
